let _elemSelector;
let _attrSelectror;

var getTimestamp = function (date) {
    return (date.getTime() / 1000) >> 0;
}

function refreshElems() {
    let now = getTimestamp(new Date());
    
    let elems = Array.from(document.querySelectorAll(_elemSelector)).filter(
        elem => {
            let refreshInterval = 0;
            try {
                refreshInterval = Number(elem.getAttribute(_attrSelectror));
            } catch (e) {;}

            return !isNaN(refreshInterval) && refreshInterval > 0;         
        } 
    );

    for (let elem of elems) { 
        if (!('timestamp' in elem.dataset)) {
            elem.dataset.timestamp = now;
        } else if (now > Number(elem.dataset.timestamp) + Number(elem.getAttribute(_attrSelectror))) {
            let refresh_param =  "_=" + now;
   
            if (/_\=(\d+)/.test(elem.src)) {
                elem.src = elem.src.replace(/_\=(\d+)/, refresh_param);       
            } else if (/[?&]/.test(elem.src)) {
                elem.src = elem.src + "&" + refresh_param;
            } else {
                elem.src = elem.src + "?" + refresh_param;
            }

            elem.dataset.timestamp = now;
        } else {
            continue;
        }
    }
}

export default function({elemSelector = "img", attrSelectror = "data-refresh"} = {}) {
    _elemSelector = elemSelector;
    _attrSelectror = attrSelectror;
   
    let refreshTimer =  setInterval(refreshElems, 1000);
}

